import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/Card';
import { ChartContainer, ChartTooltipContent } from '../components/Chart';
import { BarChart, Bar, XAxis, Tooltip, Legend, PieChart, Pie, Cell, LineChart, Line, ResponsiveContainer } from 'recharts';
import { FileText, Receipt, Send, MessageSquare, CheckCircle, Target, ThumbsUp, Clock } from 'lucide-react';
const kpiData = [{
  title: 'Discharge Summaries Generated',
  value: '311',
  icon: FileText,
  color: '#3B82F6',
  data: [10, 25, 15, 30, 20, 40, 35]
}, {
  title: 'Billing Sheets Created',
  value: '298',
  icon: Receipt,
  color: '#14B8A6',
  data: [15, 20, 25, 22, 30, 28, 35]
}, {
  title: 'Insurance Submissions Made',
  value: '276',
  icon: Send,
  color: '#8B5CF6',
  data: [5, 15, 10, 25, 20, 30, 25]
}, {
  title: 'Queries Auto-Resolved',
  value: '43',
  icon: MessageSquare,
  color: '#22C55E',
  data: [2, 5, 3, 8, 6, 12, 10]
}, {
  title: 'Overall Success Rate',
  value: '98%',
  icon: CheckCircle,
  color: '#22C55E',
  data: [95, 96, 95, 97, 98, 98, 98]
}, {
  title: 'Avg. Billing Accuracy',
  value: '96.4%',
  icon: Target,
  color: '#C8892A',
  data: [92, 93, 94, 95, 94, 96, 96.4]
}, {
  title: 'Claims Accepted (First Pass)',
  value: '89%',
  icon: ThumbsUp,
  color: '#F97316',
  data: [80, 82, 85, 84, 87, 88, 89]
}, {
  title: 'Time Saved per Patient',
  value: '2.1 hrs',
  icon: Clock,
  color: '#EF4444',
  data: [1.5, 1.6, 1.8, 1.7, 1.9, 2.0, 2.1]
}];
const pipelineVolumeData = [{
  date: '18/03',
  discharge: 20,
  billing: 18,
  insurance: 15,
  query: 2
}, {
  date: '19/03',
  discharge: 25,
  billing: 22,
  insurance: 20,
  query: 3
}, {
  date: '20/03',
  discharge: 22,
  billing: 20,
  insurance: 18,
  query: 1
}, {
  date: '21/03',
  discharge: 30,
  billing: 28,
  insurance: 25,
  query: 4
}, {
  date: '22/03',
  discharge: 28,
  billing: 25,
  insurance: 22,
  query: 3
}, {
  date: '23/03',
  discharge: 35,
  billing: 32,
  insurance: 28,
  query: 5
}, {
  date: '24/03',
  discharge: 32,
  billing: 30,
  insurance: 26,
  query: 4
}, {
  date: '25/03',
  discharge: 40,
  billing: 38,
  insurance: 35,
  query: 6
}, {
  date: '26/03',
  discharge: 38,
  billing: 35,
  insurance: 32,
  query: 5
}, {
  date: '27/03',
  discharge: 45,
  billing: 42,
  insurance: 38,
  query: 7
}, {
  date: '28/03',
  discharge: 42,
  billing: 40,
  insurance: 36,
  query: 6
}, {
  date: '29/03',
  discharge: 50,
  billing: 48,
  insurance: 45,
  query: 8
}, {
  date: '30/03',
  discharge: 48,
  billing: 45,
  insurance: 42,
  query: 7
}, {
  date: '31/03',
  discharge: 55,
  billing: 52,
  insurance: 48,
  query: 9
}];
const pipelineConfig = {
  discharge: {
    label: 'Discharge Summary',
    color: '#3B82F6'
  },
  billing: {
    label: 'Billing Sheet',
    color: '#14B8A6'
  },
  insurance: {
    label: 'Insurance Submission',
    color: '#8B5CF6'
  },
  query: {
    label: 'Query Resolution',
    color: '#C8892A'
  }
};
const outcomesData = [{
  name: 'Accepted',
  value: 245,
  color: '#22C55E'
}, {
  name: 'Disputed',
  value: 15,
  color: '#C8892A'
}, {
  name: 'Pending',
  value: 12,
  color: '#64748B'
}, {
  name: 'Resolved',
  value: 4,
  color: '#166534'
}];
const outcomesConfig = {
  accepted: {
    label: 'Accepted',
    color: '#22C55E'
  },
  disputed: {
    label: 'Disputed',
    color: '#C8892A'
  },
  pending: {
    label: 'Pending',
    color: '#64748B'
  },
  resolved: {
    label: 'Resolved',
    color: '#166534'
  }
};
export function Dashboard() {
  return <div className="p-4 lg:p-6 max-w-[1600px] mx-auto space-y-4" data-id="element-451">
      <div data-id="element-452">
        <h1 className="font-heading text-2xl sm:text-3xl font-normal text-foreground mb-1" data-id="element-453">
          Dashboard
        </h1>
        <p className="text-muted-foreground text-sm" data-id="element-454">
          Monitor your billing and insurance automations
        </p>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3" data-id="element-455">
        {kpiData.map((kpi, i) => <Card key={i} className="overflow-hidden min-w-0" data-id="element-456">
            <CardContent className="p-3" data-id="element-457">
              <div className="flex justify-between items-start mb-2 gap-2" data-id="element-458">
                <span className="text-xs font-medium text-muted-foreground line-clamp-2 leading-tight" data-id="element-459">
                  {kpi.title}
                </span>
                <div className="p-1.5 rounded-full bg-secondary flex-shrink-0" data-id="element-460">
                  <kpi.icon className="w-3.5 h-3.5 text-foreground" data-id="element-461" />
                </div>
              </div>
              <div className="flex items-end justify-between gap-2" data-id="element-462">
                <div className="min-w-0" data-id="element-463">
                  <div className="font-heading text-2xl font-normal text-foreground truncate leading-none" data-id="element-464">
                    {kpi.value}
                  </div>
                  <div className="text-[10px] text-muted-foreground mt-1" data-id="element-465">
                    Last 14 days
                  </div>
                </div>
                <div className="h-8 w-16 flex-shrink-0" data-id="element-466">
                  <ResponsiveContainer width="100%" height="100%" data-id="element-467">
                    <LineChart data={kpi.data.map((val, idx) => ({
                  val,
                  idx
                }))} data-id="element-468">
                      <Line type="monotone" dataKey="val" stroke={kpi.color} strokeWidth={2} dot={false} isAnimationActive={false} data-id="element-469" />
                    </LineChart>
                  </ResponsiveContainer>
                </div>
              </div>
            </CardContent>
          </Card>)}
      </div>

      {/* Charts Row */}
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-3" data-id="element-470">
        <Card className="xl:col-span-2 min-w-0" data-id="element-471">
          <CardHeader className="pb-2 pt-3 px-4" data-id="element-472">
            <CardTitle className="font-heading text-base font-normal" data-id="element-473">
              Agent Pipeline Volume
            </CardTitle>
          </CardHeader>
          <CardContent className="px-2 pb-3 pt-0" data-id="element-474">
            <div className="h-[220px] w-full" data-id="element-475">
              <ChartContainer config={pipelineConfig} className="!aspect-auto h-full w-full" data-id="element-476">
                <BarChart data={pipelineVolumeData} margin={{
                top: 10,
                right: 10,
                left: 0,
                bottom: 0
              }} data-id="element-477">
                  <XAxis dataKey="date" axisLine={false} tickLine={false} tick={{
                  fontSize: 10,
                  fill: '#6B6560'
                }} interval={1} dy={5} data-id="element-478" />
                  <Tooltip content={<ChartTooltipContent data-id="element-480" />} cursor={{
                  fill: 'rgba(0,0,0,0.05)'
                }} data-id="element-479" />
                  <Legend verticalAlign="top" wrapperStyle={{
                  fontSize: 11,
                  paddingBottom: 8
                }} data-id="element-481" />
                  <Bar dataKey="discharge" stackId="a" fill="var(--color-discharge)" radius={[0, 0, 4, 4]} data-id="element-482" />
                  <Bar dataKey="billing" stackId="a" fill="var(--color-billing)" data-id="element-483" />
                  <Bar dataKey="insurance" stackId="a" fill="var(--color-insurance)" data-id="element-484" />
                  <Bar dataKey="query" stackId="a" fill="var(--color-query)" radius={[4, 4, 0, 0]} data-id="element-485" />
                </BarChart>
              </ChartContainer>
            </div>
          </CardContent>
        </Card>

        <Card data-id="element-486">
          <CardHeader className="pb-2 pt-3 px-4" data-id="element-487">
            <CardTitle className="font-heading text-base font-normal" data-id="element-488">
              Insurance Claim Outcomes
            </CardTitle>
          </CardHeader>
          <CardContent className="flex flex-col items-center justify-center h-[220px] relative px-2 pb-3 pt-0" data-id="element-489">
            <ChartContainer config={outcomesConfig} className="!aspect-auto w-full h-full" data-id="element-490">
              <PieChart data-id="element-491">
                <Pie data={outcomesData} cx="50%" cy="50%" innerRadius={55} outerRadius={80} paddingAngle={2} dataKey="value" stroke="none" data-id="element-492">
                  {outcomesData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-493" />)}
                </Pie>
                <Tooltip content={<ChartTooltipContent data-id="element-495" />} data-id="element-494" />
                <Legend verticalAlign="bottom" wrapperStyle={{
                fontSize: 11
              }} data-id="element-496" />
              </PieChart>
            </ChartContainer>
            <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none pb-6" data-id="element-497">
              <span className="font-heading text-2xl font-normal text-foreground" data-id="element-498">
                276
              </span>
              <span className="text-[10px] text-muted-foreground" data-id="element-499">
                Total Submissions
              </span>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>;
}